import React from "react";
import { Col, Row, Button, Modal } from "react-bootstrap";
import { Formik, Form } from "formik";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import { CircularProgress } from "@material-ui/core";
import { addVirtualTokenAsync } from "../../redux";

const AddVirtualToken = ({ showAddTemplate, setShowAddTemplate }) => {
  const dispatch = useDispatch();

  const initialValues = {
    title: "",
    amount: "",
    token: "",
  };
  //call after template data save to close model
  const redirectBack = () => {
    setShowAddTemplate(false);
  };
  //formik validation schema
  const addEmailSchema = Yup.object().shape({
    title: Yup.string()
      .trim()
      .notOneOf(
        ["null", "NULL", "Null", "Undefined", "undefined"],
        "Please enter title"
      )
      .required("Please enter title"),
    amount: Yup.string()
      .required("Please enter amount")
      .max(15, "Amount must be no more than 15 digits in length")
      .matches(
        /^(?!0$)\d{1,15}(\.\d+)?$/,
        "Amount must be a valid number and not 0"
      ),
    token: Yup.string()
      .required("Please enter token")
      .max(15, "Token must be no more than 15 digits in length")
      .matches(
        /^(?!0$)\d{1,15}(\.\d+)?$/,
        "Token must be a valid number and not 0"
      ),
  });

  return (
    <>
      <Modal
        show={showAddTemplate}
        onHide={() => setShowAddTemplate(false)}
        centered
        className="def_modal delete_modal"
        enforceFocus={false}
      >
        <Modal.Header closeButton>
          <Modal.Title className="fn_s_18 color_blk f-w-700">
            Add Virtual Token
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={addEmailSchema}
            onSubmit={(values, { setSubmitting, resetForm }) => {
              setSubmitting(true);
              dispatch(
                addVirtualTokenAsync(
                  values,
                  setSubmitting,
                  resetForm,
                  redirectBack
                )
              );
            }}
          >
            {({
              values,
              errors,
              touched,
              isSubmitting,
              handleBlur,
              handleChange,
            }) => (
              <Row className="justify-content-center">
                <Col lg={12}>
                  <Form className="form def_form frmwtpddng">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label className="form-label">Title</label>
                          <input
                            placeholder="Enter Title"
                            type="text"
                            name="title"
                            className={
                              errors.title && touched.title
                                ? "form-control re_inputRouded is-invalid border-less-input"
                                : "form-control re_inputRouded border-less-input"
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.title}
                          />
                          {touched.title && errors.title ? (
                            <div className="fv-plugins-message-container">
                              <div className="fv-help-block">
                                {errors.title}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label className="form-label">Amount {`(USD)`}</label>
                          <input
                            placeholder="Enter Amount"
                            type="text"
                            name="amount"
                            className={
                              errors.amount && touched.amount
                                ? "form-control re_inputRouded is-invalid border-less-input"
                                : "form-control re_inputRouded border-less-input"
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.amount}
                          />
                          {touched.amount && errors.amount ? (
                            <div className="fv-plugins-message-container">
                              <div className="fv-help-block">
                                {errors.amount}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label className="form-label">Token</label>
                          <input
                            placeholder="Enter Token"
                            type="text"
                            name="token"
                            className={
                              errors.token && touched.token
                                ? "form-control re_inputRouded is-invalid border-less-input"
                                : "form-control re_inputRouded border-less-input"
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.token}
                          />
                          {touched.token && errors.token ? (
                            <div className="fv-plugins-message-container">
                              <div className="fv-help-block">
                                {errors.token}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    <div className="form-group mb-0 mt-4">
                      <div className="mb-1 mt-2">
                        {isSubmitting ? (
                          <div className="ml-3 basic-verification-loader text-center">
                            <CircularProgress />
                          </div>
                        ) : (
                          <Button
                            variant="blue"
                            className="px-5 defpddng spinnerBtn btn_new add-avtar-btn d-flex justify-content-center"
                            size="lg"
                            type="submit"
                          >
                            Submit
                          </Button>
                        )}
                      </div>
                    </div>
                  </Form>
                </Col>
              </Row>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default AddVirtualToken;
